<template>
  <div class="active">
    <div class="activeBox">
      <ProductContent :title="title" :content="content" />
      <ActivityContent :newsList="newsList" :zpList="zpList"></ActivityContent>
      <p
        :style="{ color: '#999999', cursor: 'pointer' }"
        @click="onMore()"
        class="more"
      >
        查看更多>>>
      </p>
    </div>
  </div>
</template>
<script>
import ProductContent from '@/components/ProductContent'
import ActivityContent from '@/components/ActivityContent'
export default {
  components: {
    ProductContent,
    ActivityContent,
  },
  data() {
    return {
      title: '近期动态',
      content: '了解最新的鲁商通新闻，获知最热的鲁商通动态',
      newsList: [
        {
          url: 'https://mp.weixin.qq.com/s/OnexuWw05fifO4DfN2G-yQ',
          title: '鲁商通召开2025年度工作会议',
          time: '2025-2-14',
        },
        {
          url: 'https://mp.weixin.qq.com/s/wqXZrPKiO6ii0mgzgegwkA',
          title: '打造“一盘货”，鲁商臻选把小小橙子卖成爆款',
          time: '2025-2-9',
        },
        {
          url: 'https://mp.weixin.qq.com/s/1UOxuGdeHu1VllL5kk-nvA',
          title: '鲁商通党支部组织开展党纪法规学习暨集体廉政谈话会议',
          time: '2024-11-28',
        },
        {
          url: 'https://mp.weixin.qq.com/s/wID6KGWhoAF18qW4wqE7Pw',
          title: '鲁商通赴新明辉集团考察交流',
          time: '2024-10-31',
        },
        {
          url: 'https://mp.weixin.qq.com/s/aQUOM1IV2MQ9hplVQCak3g',
          title: '鲁商通党支部开展主题党日活动',
          time: '2024-6-11',
        },
      ],
      zpList: [
        {
          url: 'https://mp.weixin.qq.com/s/46anOQ4W4DrMbZ1P-MaV4g',
          title: '榜样力量丨鲁商通的逆势突围变革之道',
          time: '2025-2-14',
        },
        {
          url: 'https://mp.weixin.qq.com/s/bMf5XV50xikNqo5ZdqbzZQ',
          title: '泉新高品创始人团队一行到访鲁商通',
          time: '2025-2-10',
        },
        {
          url: 'https://mp.weixin.qq.com/s/Lul241lQuVOfDj2giwTY0A',
          title: '精准定位 用心服务|鲁商通沙龙活动再继续',
          time: '2024-11-27',
        },
        {
          url: 'https://mp.weixin.qq.com/s/Tt40BHLo7TavInviDcoGrw',
          title: '科技赋能，鲁商通借力AI提质效',
          time: '2024-5-11',
        },
        {
          url: 'https://mp.weixin.qq.com/s/TjKvef_raiol44ztv7YUsQ',
          title: '4万+！鲁商臻选直播观看人数取得新突破',
          time: '2024-5-8',
        },
      ],
    }
  },
  methods: {
    onMore() {
      this.$router.push({ name: 'NewPage' })
    },
  },
}
</script>
<style scoped lang="scss">
.active {
  color: #000000;
  text-align: right;

  .activeBox {
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 150px;
  }
}

// .contentBox {
//   display: flex;
//   justify-content: space-between;
//   padding-bottom: 40px;
//   .content {
//     padding: 40px 35px 50px 35px;
//     background: rgba(255, 255, 255, 1);
//     box-shadow: 0px 3px 25px 2px rgba(40, 13, 13, 0.04);
//     width: 570px;
//   }
// }
// .vertical {
//   width: 3px;
//   height: 24px;
//   background: #eb6100;
//   border-radius: 1px 1px 1px 1px;
//   display: inline-block;
//   margin-right: 14px;
//   margin-bottom: -4px;
// }
// .zpintro {
//   margin-top: 10px;
//   a {
//     display: flex;
//     justify-content: space-between;
//     color: #000000;
//     text-decoration: none;
//   }
// }
@media (max-width: 767.98px) {
  ::v-deep .midText {
    background: #f2f2f2;
  }

  .more {
    display: none;
  }

  .activeBox {
    width: 100% !important;
  }

  .active {
    background-color: #f2f2f2;
    padding-top: 40px;
  }
}
</style>
